import { ApolloClient, ApolloLink, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { InMemoryCache } from '@apollo/client/cache';
import { AuthError } from 'utils/errors';

import { handleGraphqlError } from 'utils/handleGraphqlError';
import conf from 'client/conf';
import { getWebApiUrl } from 'client/utils/webApi';

const marketplaceLink = new HttpLink({ uri: conf.MARKETPLACE_URL });
const strideWebLink = new HttpLink({ uri: getWebApiUrl() });
const errorLink = onError(handleGraphqlError);

const strideAuthLink = setContext(async (_req, { headers }) => {
  const { personId } = window.__INITIAL_STATE__;
  const customHeaders = {
    userid: personId,
    role: 'CONSUMER_DE',
  };

  if (!customHeaders.userid) {
    throw new AuthError('No userid found--user must be logged in');
  }

  return {
    headers: {
      ...headers,
      ...customHeaders,
      'x-use-session-id': 'true',
    },
  };
});

const apolloLink = ApolloLink.split(
  operation => operation.getContext().clientName === 'marketplace',
  marketplaceLink,
  strideAuthLink.concat(strideWebLink),
);

// NOTE: The ApolloClient here for local development config
// Will need to add this in client app e.g. stride-web-express, when passing ApolloClient to EDE-UI
export const getApolloClient = () =>
  new ApolloClient({
    ssrMode: true,
    link: from([errorLink, apolloLink]),
    cache: new InMemoryCache({
      typePolicies: {
        EdeApplication: {
          keyFields: ['insuranceApplicationIdentifier'],
        },
      },
      addTypename: false,
      strictNullChecks: false,
    }),
  });
